"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _constants = require("../../constants");

var _Portal = _interopRequireDefault(require("../Portal"));

var _DrawerOverlay = _interopRequireDefault(require("./DrawerOverlay"));

var _DrawerTitle = _interopRequireDefault(require("./DrawerTitle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const StyledDrawer = _styledComponents.default.div`
	position: fixed;
	top: 0;
	right: 0;
	width: 100vw;
	height: 100vh;
	padding-top: 100px;
	background-color: ${_constants.colours.paleGrey};
	z-index: 999;

	@media (min-width: ${_constants.breakpoints.smallDesktop}) {
		width: 526px;
		padding-top: unset;
	}

	@keyframes AnimateInOut {
		0% {
			transform: translateX(100vw);
		}

		100% {
			transform: translateX(0);
		}
	}

	${({
  state
}) => state === 'opening' && `
    animation: AnimateInOut .2s forwards;
	`}

	${({
  state
}) => state === 'open' && `
			transform: translateX(0);
	`}

	${({
  state
}) => state === 'closing' && `
    	animation: AnimateInOut .2s reverse forwards;
	`}
	
	${({
  state
}) => state === 'closed' && `
			transform: translateX(100vw);
	`}
`;

const Drawer = ({
  title,
  state,
  closeButtonAction,
  children,
  ...rest
}) => {
  const handleEscapeKey = e => {
    if (e.key === 'Escape') {
      closeButtonAction();
    }
  };

  (0, _react.useEffect)(() => {
    document.addEventListener('keydown', handleEscapeKey);
    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, []);
  return state !== 'closed' ? /*#__PURE__*/_react.default.createElement(_Portal.default, null, /*#__PURE__*/_react.default.createElement(_DrawerOverlay.default, {
    state: state
  }), /*#__PURE__*/_react.default.createElement(StyledDrawer, _extends({
    state: state
  }, rest, {
    role: "menubar"
  }), /*#__PURE__*/_react.default.createElement(_DrawerTitle.default, {
    title: title,
    closeButtonAction: closeButtonAction
  }), children)) : null;
};

Drawer.propTypes = {
  title: _propTypes.string.isRequired,
  state: _propTypes.string.isRequired,
  closeButtonAction: _propTypes.func.isRequired,
  children: _propTypes.node.isRequired
};
var _default = Drawer;
exports.default = _default;